import {FormModel} from './form.model.abstract';
import {ValidatorFn} from '@angular/forms';

/**
 * Two date fields
 * @inheritDoc
 */
export class FormModelCheckboxes extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'checkboxes';

  /**
   * @inheritDoc
   */
  constructor(id: string, options: string[], validators: ValidatorFn[] = [], unit: string = null, values: string[], info: boolean = true) {
    super(id, validators, unit, null, info);

    this.fieldData.values = values;
    this.options = options;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelCheckboxes {
    // @ts-ignore
    return new this.constructor(this.id, this.options, this.validators, this.unit, this.fieldData.values, this.info);
  }

  /**
   * @inheritDoc
   */
  getIds(): string[] {
    return this.getOptions().map(option => this.id + '_' + option);
  }

  /**
   * set the fieldvalues
   * @param values
   */
  setValues(values: boolean[]): void {
    this.fieldData.values = values;
  }
}
